import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LoginComponent from "components/Login/index.js";
// import history from "../../history";
import * as loginAction from "./actions.js";
import { getValue, EMAIL_PATTERN, isEmpty, isValueValid } from "utilities/app.js";
import history from "../../history";

const LoginContainer = props => {
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  const [isButtonClick, setButtonClick] = useState(false);

  const [formStateForUserInput, setFormStateForUserInput] = useState({
    email: '',
    password: ''
  });

  const [errorStateForUserInput, setErrorStateForUserInput] = useState({
    email: '',
    password: ''
  });

  useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });

  useEffect(() => {
    if (props.isLoginSuccess) {
        history.push('/');
    }

}, [props.isLoginSuccess]);

  const onHandleChange = (event) => {
    console.log('event: ', event.target);
    let name = event.target.name;
    let value = event.target.value;
    let formData = { ...formStateForUserInput };
    formData[name] = value;
    setFormStateForUserInput(formData);
    console.log('value: ', value);
    validateData(name, value);
  };




  const validateData = (name, value) => {
    console.log("value====>",value)
    let errorObject = errorStateForUserInput;
    switch (name) {
      case "email":
        errorObject.email = "";
        if (isEmpty(value)) {
          errorObject.email = "Email id required!";
        }
        else if (!isValueValid(value.trim(), EMAIL_PATTERN)) {
          errorObject.email = "Please Enter Valid  Email id";
        }
        break;
      case "password":
        errorObject.password = "";
        if (isEmpty(value)) {
          errorObject.password = "Password id required!";
        }

        break;

    };
    setErrorStateForUserInput(errorObject);
  };


  const isAllFieldsValid = () => {

    let formErrors = errorStateForUserInput;
    let isAllValid = true;
    for (let fieldName in formErrors) {
      validateData(fieldName, formStateForUserInput[fieldName]);

      if (formErrors[fieldName].length > 0) {
        isAllValid = false;
      }
    }
    return isAllValid;
  }



  function onButtonClick() {
    setButtonClick(true);
    if (isAllFieldsValid()) {
      let data = {};
      Object.keys(formStateForUserInput).forEach((dta) => {
        data[dta] = formStateForUserInput[dta];

      });
      props.loginAction.doLogin(data);

    }
  }

  return (
    <>
      <LoginComponent
        onSubmit={onButtonClick}
        cardAnimaton={cardAnimaton}
        onHandleChange={onHandleChange}
        formState={formStateForUserInput}
        errorState={errorStateForUserInput}
        isButtonClick={isButtonClick}
        isFromLoginPage={true}
      />
    </>
  );
};

const mapStateToProps = state => {
  return {
    // registration: state.authenticationReducer.registration
    isLoginSuccess: state.login.isLoginSucess
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginAction: bindActionCreators(loginAction, dispatch)
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
